import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function OfferSection() {
  const benefits = ['10 module video structurate, pas cu pas', 'Un apel de mentorat 1:1 în fiecare lună', 'Materiale de suport tehnic incluse', 'Comunitate WhatsApp cu alți cursanți', 'Promovare directă către angajatori din rețea'];
  return <section className="py-20 md:py-28 lg:py-32 bg-brand-black" data-id="element-170">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-brand-white uppercase tracking-industrial mb-4" data-id="element-173">
            Cum poți lucra cu mine
          </h2>
          <p className="font-sub font-medium italic text-brand-muted text-lg" data-id="element-174">
            Alege varianta care ți se potrivește.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center" data-id="element-175">
          {/* Photo side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative h-[400px] md:h-[500px] rounded-lg overflow-hidden border border-brand-border hidden lg:block" data-id="element-176">
            <img src="https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80&auto=format&fit=crop" alt="Formare practică în instalații" className="w-full h-full object-cover" data-id="element-177" />
            <div className="absolute inset-0 bg-gradient-to-r from-brand-black/60 via-brand-black/20 to-transparent" data-id="element-178" />
            <div className="absolute bottom-6 left-6" data-id="element-179">
              <div className="bg-brand-black/70 backdrop-blur-sm px-4 py-2 rounded border border-brand-border" data-id="element-180">
                <span className="font-heading font-bold text-brand-accent text-xs uppercase tracking-industrial" data-id="element-181">
                  Mentorat practic, nu doar teorie
                </span>
              </div>
            </div>
          </motion.div>

          {/* Offer card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-brand-grey border border-brand-border hover:border-brand-accent transition-colors duration-500 rounded-lg p-8 md:p-10 relative overflow-hidden group" data-id="element-182">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-brand-accent opacity-0 group-hover:opacity-100 transition-opacity duration-500 accent-glow" data-id="element-183" />

            <div className="text-center mb-8" data-id="element-184">
              <h3 className="font-heading font-black text-2xl md:text-3xl text-brand-white uppercase tracking-industrial mb-4" data-id="element-185">
                Programul Complet 6 Luni
              </h3>
              <div className="inline-block bg-brand-dark border border-brand-border px-6 py-2 rounded-full" data-id="element-186">
                <span className="font-sub font-medium italic text-brand-accent text-base" data-id="element-187">
                  Cursuri online și mentorat 1:1
                </span>
              </div>
            </div>

            <ul className="space-y-5 mb-10" data-id="element-188">
              {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-189">
                  <div className="w-6 h-6 rounded-full bg-brand-accent/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-190">
                    <CheckIcon className="w-4 h-4 text-brand-accent" data-id="element-191" />
                  </div>
                  <span className="font-body text-brand-white text-base" data-id="element-192">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <a href="https://wa.link/udb2nf" target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-brand-accent text-brand-black font-heading font-bold uppercase tracking-industrial px-8 py-5 rounded-[4px] hover:bg-white transition-all duration-300 accent-glow-hover text-base" data-id="element-193">
              Vreau detalii despre program
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}